import React from "react";
import { toast } from "react-toastify";

const CardModal = ({
    show,
    onClose,
    input,
    setInput,
    getAmountDue,
    getReminingValue,
    handleSubmit,
    CustomerId,
    isSales = false,
    loading = false
}) => {
    const amountDue = parseFloat(getAmountDue());
    const remainingValue = getReminingValue();

    const handleChange = (e) => {
        let value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) { // Allow only numbers & decimals
            if (parseFloat(value) > amountDue) {
                value = amountDue.toString(); // Restrict input to amountDue
            }
            setInput(value);
        }
    };

    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            style={{ display: show ? "block" : "none" }}
            tabIndex="-1"
            role="dialog"
        >
            <div className="modal-dialog">
                <div className="modal-content p-3">

                    {/* Modal Header */}
                    <div className="modal-header border-0">
                        <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-6">
                                {/* Payment Summary Section */}
                                {[
                                    { label: "Total", value: amountDue, disabled: true },
                                    { label: "Card Amount", value: input, disabled: false, onChange: handleChange },
                                    { label: "Credit", value: remainingValue, disabled: true }
                                ].map(({ label, value, disabled, onChange }, index) => (
                                    <div key={index} className="mb-2">
                                        <label className="text-sm font-semibold text-gray-700 w-100">{label}</label>
                                        <input
                                            type="text"
                                            value={value}
                                            disabled={disabled}
                                            onChange={onChange}
                                            className={`w-100 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none ${label == "Credit" ? 'bg-warning-subtle' : ''}`}
                                        />
                                    </div>
                                ))}

                                {/* Pay Button */}
                                <button
                                    onClick={() => {
                                        if (loading) return;
                                        if (getReminingValue() > 0 && isSales) {
                                            console.log(getReminingValue())
                                            if (CustomerId) {
                                                handleSubmit(4)
                                            } else {
                                                toast.error("Customer details are required for credit sales.")
                                            }
                                        } else {
                                            handleSubmit(4)
                                        }
                                    }}
                                    disabled={loading || !input || parseFloat(input) <= 0}
                                    style={{ pointerEvents: loading ? 'none' : 'auto' }}
                                    className="w-full mt-2 btn btn-success text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-blue-700 transition d-flex align-items-center justify-content-center gap-2"
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Processing...
                                        </>
                                    ) : (
                                        "Pay"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CardModal;
